export const getResumeData = state =>
  state.resumeBuilder && state.resumeBuilder.Steps;

export const getCareerCraftData = state =>
  state.resumeBuilder && state.resumeBuilder.CareerCraft;

export const getLinkedInDetails = state => {
  return state.resumeBuilder && state.resumeBuilder.LinkedInDetails;
};
